import envConfig from 'configs/envConfig';
import analyticsService from 'infrastructure/serviceHandlers/Analytics/Analytics';

export const enableCleverTap =
  envConfig('env') === 'dev' ||
  envConfig('env') === 'prod' ||
  envConfig('env') === 'staging' ||
  envConfig('env') === 'luna-stg' ||
  envConfig('env') === 'luna' ||
  envConfig('env') === 'homiq-stg' ||
  envConfig('env') === 'homiq-prod' ||
  envConfig('env') === 'haloview-stg' ||
  envConfig('env') === 'haloview-prod' ||
  envConfig('env') === 'waiscen-stg' ||
  envConfig('env') === 'waiscen-prod' ||
  envConfig('env') === 'newaieye-stg' ||
  envConfig('env') === 'newaieye-prod' ||
  envConfig('env') === 'iv_sandbox-prod';

// A stored userId means a returning, already-identified session — see
// `identified` in CleverTap.ts. Logout clears localStorage. Storage can throw
// (blocked site data); then the user is identified at login as before.
const hasStoredUser = (): boolean => {
  try {
    return !!localStorage.getItem('userId');
  } catch {
    return false;
  }
};

const cleverTapKey = envConfig('cleverTapKey');
if (cleverTapKey && enableCleverTap) {
  analyticsService.initialize(cleverTapKey, {
    region: 'in1',
    identified: hasStoredUser()
  });
  // Fetch Remote Config (feature-flag) values on boot so variants are ready
  // for returning users; first-time users fall back to defaults until this
  // resolves.
  analyticsService.fetchExperiment();
}
